var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-select',{attrs:{"placeholder":"choose reason","multiple":_vm.isMultiple,"filterable":true},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.options),function(item,index){return _c('vs-select-item',{key:index,attrs:{"value":item.ID,"text":item.reason}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }